<style>
.custom-select {
  -webkit-text-size-adjust: 100%;
  color: #34495e;
  text-align: left;
  -webkit-box-direction: normal;
  word-wrap: break-word;
  border: 0;
  font: inherit;
  vertical-align: baseline;
  box-sizing: border-box;
  outline: none;
  margin: 0;
  padding: 0;
  background: #f5f8f9;
  border-radius: 0.5rem;
  width: 100%;
  height: 47px;
  line-height: 47px;
}

</style>

<template>
  <div class="loan">
    <!-- Spinner -->
    <div style="position: fixed; top: 50%; left: 50%; z-index: 999;">
      <atom-spinner
        v-if="loading"
        :animation-duration="speed"
        :size="config.size"
        :color="spinnersColor"
      />
    </div>

    <!-- Error Notification -->
    <div class="mb-3" v-if="processingError">
      <va-notification color="danger" closeable>
        An error occurred! Please try again later.
      </va-notification>
    </div>

    <div class="row">
      <div class="flex xs12 md5">
        <!-- Vuestic Card -->
        <va-card>
          <!-- Card Title -->
          <template #title>
            {{ $t('CRM.crm-MemberInquiry') }}
          </template>

          <!-- Card Content -->
          <form @submit.prevent="onsubmit">
            <!-- Reason Select -->
            <div class="va-input-wrapper va-input mb-4">
              <label
                class="va-input__container__label"
                style="color: rgb(228, 163, 78); padding-left: 5px; top: 0.5rem;"
              >
                Reason for contacting
              </label>
              <select
                v-model="formdata.reason"
                class="custom-select w-full"
                required
              >
                <option value="">---- Contacting To ----</option>
                <option value="0">Inquire</option>
                <option value="1">Request</option>
                <option value="2">Appreciation</option>
                <option value="3">Complaint</option>
                <option value="4">Criticism</option>
                <option value="5">Payment</option>
                <option value="6">Receipt</option>
                <option value="7">Loan Form</option>
              </select>
            </div>

            <!-- Description Input -->
            <va-input
              :label="$t('Description')"
              type="textarea"
              v-model="formdata.description"
              :error="!!description.length"
              :error-messages="descriptionErrors"
              class="mb-4"
            />

            <!-- Submit Button -->
            <div class="row mt-5">
              <va-button
                type="submit"
                :disabled="isLoading"
                class="mr-2"
              >
                {{ $t('forms.controls.submit') }}
              </va-button>

              <va-button
                icon="fa fa-close"
                color="danger"
                @click="$router.go(-1)"
              >
                Cancel
              </va-button>
            </div>
          </form>
        </va-card>
      </div>
    </div>
  </div>
</template>

<script src="https://unpkg.com/vue@2.5.13/dist/vue.js"></script>
<script>
import axios from 'axios'
import * as spinners from 'epic-spinners'

export default {
  components: {
    ...spinners      
  },
  name: 'loan',
  name: 'CRM',
  data () {
    return {
      userData: JSON.parse(localStorage.getItem('LoggedUser')),
      accdetails: JSON.parse(localStorage.getItem('UserMianFosa')),
      token: JSON.parse(localStorage.getItem('Token')),  
      loan_no : this.$route.params.loan_no,
      processingError: false,
      loading: false,
      isLoading: null,
      descriptionErrors : [],
      formdata:{
      	description:'',
        reason:'',
     
      },
      description:'',
        reason:'',
      config: {
        size: 80,
        duration: 1500,
      },

      spinnersColor: this.$themes.secondary,
      currentDuration: 1500,
      sliderDuration: {
        min: 1000,
        max: 2000,
      }     
    }
  },
  computed: {
    speed () {
      return this.sliderDuration.min + this.sliderDuration.max - this.currentDuration
    },
//      grossSalary(){
//         //console.log(input);
//         //console.log(parseInt(this.formdata.basicsalary) - parseInt(this.formdata.allawances));
// return  parseInt(this.formdata.basicsalary) - parseInt(this.formdata.allawances);
//     },
fields () {

    },
    filteredData () {
      if (!this.term || this.term.length < 1) {
        return this.schedule
      }
      return this.schedule.filter(item => {
        return item.date.toLowerCase().startsWith(this.term.toLowerCase())
      })
    },
    formReady () {
      return !this.descriptionErrors.length 
    }, 
         
  },
  methods : {
    GetProduct(id) {      
      return this.loans.filter(item => item.product_id.toLowerCase() === this.id.toLowerCase());      
    },
    
 
    onsubmit (e) {
      e.preventDefault();
      this.isLoading = true
      this.processingError = false;
      this.descriptionErrors = this.formdata.description ? [] : ['Decription is required']
     
     if (this.formReady) {
      this.showConfirmModal = true;
      } 
      console.log(this.product_id);
       const form = {
        
        user:this.userData.user_id,
       phonenumber: this.userData.mobile_number,
       description: this.formdata.description,
       reasonforcalling: this.formdata.reason,
       department: 'null',
        };

     		this.loading = true
				var self = this

				let config = {
					headers: {
						Authorization: this.userData.user_id+' '+this.token
					}
					}

				axios.post(`${this.$apiUrl}CrmMembersInquiry`, form, config) 
				.then(function (res) {
					self.loading = false	
    			
					const resp = res.data;
					console.log(resp);
					if(resp == "True"){ 
            self.isLoading = false	             
			          self.showToast(`Successfully sent, You will hear from us soon.`, {
			            position: 'bottom-right',
			            icon: "fa-check",
			            duration: 2500,

			          })
                self.GRequest();
      setTimeout( () =>  self.GRequest(), 2500);
      
			        } else {
			          self.processingError = true
			        }                 
				})
				.catch(function (error) {
				  console.log(error)
				})
    },
    GRequest(){

      this.$router.push({ name: 'crm-ListCRMs' }) 

    },
  },
  created () { 
 
  }
}
</script>